import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'
import { Element } from 'react-scroll'

import { Link } from 'react-router-dom'
import { getEmbedDynamically } from '../../utils/publisher'
import RemixViewer from '../../common/components/RemixViewer/RemixViewer.jsx'
import { convertPreviewUrlToRemixHTMLUrl } from '../../common/components/RemixViewer/utils.js'

const ActionSection = forwardRef((props, ref) => {
    const { activeType, currentImages, onActionClick = null, t } = props
    const [previewIndex, setPreviewIndex] = useState(0)
    const [remixUrl, setRemixUrl] = useState('')
    const containerRef = useRef()

    const changePreview = async index => {
        if (activeType.isRemixLite) {
            setRemixUrl(convertPreviewUrlToRemixHTMLUrl(activeType.previews[index]))
        } else {
            if (containerRef.current) {
                while (containerRef.current.firstChild) {
                    containerRef.current.removeChild(containerRef.current.firstChild)
                }
                getEmbedDynamically(containerRef.current, null, activeType.previews[index])
            }
        }
    }

    useEffect(() => {
        changePreview(previewIndex)
    }, [previewIndex])

    useImperativeHandle(ref, () => ({
        resetPreview: () => {
            if (previewIndex > 0) setPreviewIndex(0)
            else changePreview(0)
        },
    }))

    if (
        (activeType.isActive && !activeType.previews.length) ||
        (!activeType.isActive && !currentImages.comingSoonPreview)
    )
        return null

    const previewText =
        (activeType.texts.action && activeType.texts.action.preview) ||
        'Create projects that are interactive, visually appealing, and responsive. Segment ' +
            'your audience, maximize the engagement rates, collect leads, and stand out from the competition.'

    return (
        <Element name="landing_action_section">
            <div className={`action-section ${activeType.name}`}>
                {activeType.isActive ? (
                    <>
                        <h3>{t(activeType.texts.action.title)}</h3>
                        <div className="action-section__action-box">
                            <div className="action-section__preview-box" ref={containerRef}>
                                <RemixViewer remixUrl={remixUrl} device="desktop" />
                            </div>
                            {activeType.previews.length > 1 ? (
                                <>
                                    <ul className="action-section__arrows">
                                        <li
                                            className="action-section__arrows-left"
                                            onClick={() =>
                                                setPreviewIndex(
                                                    previewIndex !== 0
                                                        ? previewIndex - 1
                                                        : activeType.previews.length - 1,
                                                )
                                            }
                                        />
                                        <li
                                            className="action-section__arrows-right"
                                            onClick={() =>
                                                setPreviewIndex(
                                                    previewIndex !== activeType.previews.length - 1
                                                        ? previewIndex + 1
                                                        : 0,
                                                )
                                            }
                                        />
                                    </ul>
                                    <div className="action-section__navigation">
                                        <div
                                            className="action-section__navigation-left"
                                            onClick={() =>
                                                setPreviewIndex(
                                                    previewIndex !== 0
                                                        ? previewIndex - 1
                                                        : activeType.previews.length - 1,
                                                )
                                            }
                                        />
                                        <ul>
                                            {activeType.previews.map((item, i) => {
                                                return (
                                                    <li
                                                        key={i}
                                                        className={`${i === previewIndex ? 'is-active' : ''}`}
                                                        style={{
                                                            backgroundColor:
                                                                i === previewIndex ? activeType.colors.main : '#dadada',
                                                        }}
                                                        onClick={() => setPreviewIndex(i)}
                                                    />
                                                )
                                            })}
                                        </ul>
                                        <div
                                            className="action-section__navigation-right"
                                            onClick={() =>
                                                setPreviewIndex(
                                                    previewIndex !== activeType.previews.length - 1
                                                        ? previewIndex + 1
                                                        : 0,
                                                )
                                            }
                                        />
                                    </div>
                                </>
                            ) : null}
                        </div>
                        <div className="action-section__text">{t(previewText)}</div>
                        <div className="action-section__create-button">
                            {onActionClick !== null ? (
                                <button
                                    className="button"
                                    data-size="lg"
                                    data-variant="primary"
                                    onClick={onActionClick}
                                >
                                    {t(activeType.texts.action.button)}
                                </button>
                            ) : (
                                <Link
                                    to={`/template-gallery/${activeType.customId}`}
                                    className="button-style"
                                    data-size="lg"
                                    data-variant="primary"
                                >
                                    {t(activeType.texts.action.button)}
                                </Link>
                            )}
                        </div>
                    </>
                ) : (
                    <>
                        <h3>{t('Coming soon')}</h3>
                        <div className="action-section__fake-preview">
                            <img src={currentImages.comingSoonPreview} alt="" />
                            <div
                                className="action-section__fake-preview-label"
                                style={{ backgroundColor: activeType.colors.main }}
                            >
                                {t('Work in progress')}
                            </div>
                        </div>
                        <div className="action-section__text">{t(previewText)}</div>
                    </>
                )}
            </div>
        </Element>
    )
})

export default ActionSection
